import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    primary: '#409EFF'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
